import type { MouseEvent } from 'react';
import React from 'react';
import styled from '@emotion/styled';

import { Flex } from '../../Flex';
import NextControl from './NextControl';
import PrevControl from './PrevControl';

export interface ControlsProps {
  prevDisabled: boolean;
  nextDisabled: boolean;
  handlePrevControl: (e: MouseEvent<HTMLDivElement>) => void;
  handleNextControl: (e: MouseEvent<HTMLDivElement>) => void;
}

const ControlsContainer = styled(Flex)``;

const Controls = ({
  prevDisabled,
  nextDisabled,
  handlePrevControl,
  handleNextControl,
}: ControlsProps) => {
  if (prevDisabled && nextDisabled) {
    return null;
  }

  return (
    <ControlsContainer data-testid="carousel-controls">
      <PrevControl disabled={prevDisabled} handleClick={handlePrevControl} />
      <NextControl disabled={nextDisabled} handleClick={handleNextControl} />
    </ControlsContainer>
  );
};

export default Controls;
